import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import CustomInput from "@/pages/checkout/components/CustomInput/CustomInput";
import stl from "./ShopApplyForm.module.css";
import NDayGuarantee from "@/pages/checkout/components/NDayGuarantee/NDayGuarantee";
import MobileCarInfo from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/MobileCarInfo";
import { useLocation } from "react-router-dom";
import { CDN_LINK, serverUrl } from "@globalConfig";
import { cashCheckout3Event } from "@/utils/dataLayerEvents";
import Tag from "../../../../components/UiKit/Tag/Tag";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import { trackEvents } from "@/common/events/events";
import ChangeAccountVerificationModal from "@/_MiniApps/auth/ui/ChangeAccountVerificationModal/ChangeAccountVerificationModal";
import { useTranslation } from "@i18n";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useButtonLoading from "@hooks/useButtonLoading";
import useApi from "@hooks/useApi";
import { api__getCitiesDropDown } from "@/apis/assets/api__get_cities_drop_down";
import InputPhoneNumber from "@componentsShared/InputPhoneNumber/InputPhoneNumber";
import useLocalStorage from "@hooks/useLocalStorage";
import useSubmissionSource from "@hooks/useSubmissionSource";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import { toast } from "sonner";
import { ValidationException } from "@/common/exceptions/ValidationException";
import useIsMobile from "@hooks/useIsMobile";
var showToast = function showToast(msg) {
  toast.success(msg, {
    position: "bottom-center",
    duration: 2000,
    style: {
      zIndex: 9999999
    }
  });
};
var showErrorToast = function showErrorToast(msg) {
  toast.error(msg, {
    position: "bottom-center",
    duration: 5000,
    style: {
      zIndex: 9999999
    }
  });
};
var ShopApplyForm = function ShopApplyForm(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useLocalStorage = useLocalStorage(),
    setLocalStorage = _useLocalStorage.setLocalStorage;
  var location = useLocation();
  var isMobile = useIsMobile();
  var _useState = useState({}),
    errors = _useState[0],
    setErrors = _useState[1];
  var _useState2 = useState(null),
    validationException = _useState2[0],
    setValidationException = _useState2[1];
  var _useState3 = useState(false),
    showVerificationModal = _useState3[0],
    setShowVerificationModal = _useState3[1];
  var buttonLoading = useButtonLoading();
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var _useAuthActions = useAuthActions(),
    logout = _useAuthActions.logout;
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrder = _useCheckoutOrder$sta.checkoutOrder,
    formData = _useCheckoutOrder$sta.formData,
    referralData = _useCheckoutOrder$sta.referralData,
    fetching_error = _useCheckoutOrder$sta.fetching_error;
  var _useCheckoutOrder$que = useCheckoutOrder().queryParams,
    customerid = _useCheckoutOrder$que.customerid,
    referral = _useCheckoutOrder$que.referral,
    hasTawuniyaParams = _useCheckoutOrder$que.hasTawuniyaParams,
    post_id = _useCheckoutOrder$que.post_id;
  var _useCheckoutOrder$act = useCheckoutOrder().actions,
    setFormItem = _useCheckoutOrder$act.setFormItem,
    action__resetPromoCode = _useCheckoutOrder$act.action__resetPromoCode;
  var _useCheckoutOrder$rem = useCheckoutOrder().remote_actions,
    fetch__getOrderDetailsByParams = _useCheckoutOrder$rem.fetch__getOrderDetailsByParams,
    fetch__getPromoCode = _useCheckoutOrder$rem.fetch__getPromoCode,
    fetch__createOrder = _useCheckoutOrder$rem.fetch__createOrder;
  var _useSubmissionSource = useSubmissionSource(),
    getSubmissionSource = _useSubmissionSource.getSubmissionSource;
  var _useApi = useApi([], api__getCitiesDropDown),
    _useApi2 = _slicedToArray(_useApi, 3),
    loadingCities = _useApi2[0],
    errorCities = _useApi2[1],
    cities = _useApi2[2];
  useEffect(function () {
    if (fetching_error) {
      showErrorToast(fetching_error.message);
    }
  }, [fetching_error]);
  var setFormItemProxy = function setFormItemProxy(key, value) {
    setErrors(_objectSpread(_objectSpread({}, errors || {}), {}, _defineProperty({}, key, null)));
    setFormItem(key, value);
  };
  var getErrMsg = function getErrMsg(fieldName) {
    return (errors === null || errors === void 0 ? void 0 : errors[fieldName]) || (validationException === null || validationException === void 0 ? void 0 : validationException.extractErrorMessageFrom([fieldName]));
  };
  var handleValidation = function handleValidation() {
    var _formData$full_name;
    var clientSideErrors = {};
    if (!(formData !== null && formData !== void 0 && formData.full_name)) {
      clientSideErrors["full_name"] = t("يجب إختيار الاسم ", {
        ns: "web_checkout_cash"
      });
    }
    if ((formData === null || formData === void 0 ? void 0 : (_formData$full_name = formData.full_name) === null || _formData$full_name === void 0 ? void 0 : _formData$full_name.trim().length) < 5) {
      clientSideErrors["full_name"] = t("اسم العميل يجب أن يحتوي على أكثر من 5 حرف. ", {
        ns: "web_checkout_cash"
      });
    }
    if (!(formData !== null && formData !== void 0 && formData.city_id)) {
      clientSideErrors["city_id"] = t("يجب إختيار المدينة ", {
        ns: "web_checkout_cash"
      });
    }
    if (!(formData !== null && formData !== void 0 && formData.phone_number)) {
      clientSideErrors["phone_number"] = t("يجب إختيار رقم الجوال", {
        ns: "web_checkout_cash"
      });
    } else {
      if (!/^(05)[0-9]{8}$/.test(formData === null || formData === void 0 ? void 0 : formData.phone_number)) {
        clientSideErrors["phone_number"] = t("يجب أن يتكون رقم الجوال من عشر خانات وأن يحتوي أرقاماً فقط وأن يبدأ ب  05", {
          ns: "web_checkout_cash"
        });
      }
    }
    return Object.keys(clientSideErrors).length > 0 ? clientSideErrors : null;
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var clientSideErrors, unbxdParams, _checkoutOrder$g4_dat, freshOrder, submission_source, formValidationException;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e === null || e === void 0 ? void 0 : e.preventDefault();
            clientSideErrors = handleValidation();
            if (!clientSideErrors) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", setErrors(function (pre) {
              return _objectSpread(_objectSpread({}, pre), clientSideErrors);
            }));
          case 4:
            if (!(isLoggedIn && (user === null || user === void 0 ? void 0 : user.phone_number) != (formData === null || formData === void 0 ? void 0 : formData.phone_number) && !showVerificationModal)) {
              _context.next = 7;
              break;
            }
            setShowVerificationModal(true);
            return _context.abrupt("return");
          case 7:
            cashCheckout3Event(formData === null || formData === void 0 ? void 0 : formData.phone_number, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer);
            unbxdParams = {
              action: "cart",
              qty: "1",
              url: serverUrl + location.pathname + location.search,
              pid: post_id
            };
            unbxdAnalytics(unbxdParams);
            _context.prev = 10;
            _context.next = 13;
            return fetch__createOrder();
          case 13:
            freshOrder = _context.sent;
            setLocalStorage("otp_visited_".concat(freshOrder === null || freshOrder === void 0 ? void 0 : freshOrder.id), "0");
            submission_source = getSubmissionSource();
            trackEvents("cash_form_submit", _objectSpread(_objectSpread({
              order_id: freshOrder === null || freshOrder === void 0 ? void 0 : freshOrder.id
            }, checkoutOrder.g4_data_layer), {}, {
              post_trim: checkoutOrder.g4_data_layer.post_ext,
              discount_code: (formData === null || formData === void 0 ? void 0 : formData.code) || null,
              total_amount: parseFloat(checkoutOrder.total_price.replace(/,/g, "")),
              inventory_type_string: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat === void 0 ? void 0 : _checkoutOrder$g4_dat.inventory_type_string,
              user_city: cities.find(function (city) {
                return city.id == (formData === null || formData === void 0 ? void 0 : formData.city_id);
              }).name_en,
              referral_location: submission_source
            }));
            props.setShowOtp(true);
            _context.next = 23;
            break;
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](10);
            if (_context.t0 instanceof ValidationException) {
              formValidationException = _context.t0;
              setValidationException(formValidationException);
              showErrorToast(formValidationException.getAllErrorMessages());
            }
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[10, 20]]);
    }));
    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var activateTheCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(value) {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch__getPromoCode(value);
          case 2:
            data = _context2.sent;
            if (data && !data.valid) {
              setErrors(_objectSpread(_objectSpread({}, errors || {}), {}, {
                code: data.error
              }));
              setTimeout(function () {
                setErrors(_objectSpread(_objectSpread({}, errors || {}), {}, {
                  code: null
                }));
              }, 3000);
            } else {
              fetch__getOrderDetailsByParams({
                code: value
              });
            }
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function activateTheCode(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (user) {
      setFormItem("full_name", user === null || user === void 0 ? void 0 : user.full_name);
      setFormItem("phone_number", user === null || user === void 0 ? void 0 : user.phone_number);
    }
    if (hasTawuniyaParams) {
      setFormItem("referral", referral);
      setFormItem("customerid", customerid);
    }
  }, []);
  useEffect(function () {
    document.title = "".concat(t("مراجعة التفاصيل", {
      ns: "web_checkout_cash"
    }), "  ").concat(checkoutOrder ? checkoutOrder.post_title : "");
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: props.style ? props.style : undefined,
    className: [stl.container, props.loading ? stl.formLoad : undefined].join(" ")
  }, props.loading && /*#__PURE__*/React.createElement("div", {
    className: ["textLoading textLoadingPage", stl.posAbs].join(" ")
  }), isMobile && /*#__PURE__*/React.createElement(MobileCarInfo, {
    className: "".concat(stl.mobileCarInfoCard),
    checkoutOrder: checkoutOrder,
    hideTitle: true,
    onClickInfoIcon: props.onClickInfoIcon
  }), /*#__PURE__*/React.createElement("strong", {
    className: stl.hdr
  }, t("أضف معلوماتك", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CustomInput, {
    name: "full_name",
    className: stl.rowData,
    label: t("الاسم بالكامل", {
      ns: "web_checkout_cash"
    }),
    type: "text",
    placeholder: t("اسمك بالكامل", {
      ns: "web_checkout_cash"
    }),
    error: getErrMsg("full_name"),
    handleChange: function handleChange(target) {
      setFormItemProxy("full_name", target.value);
    },
    value: formData === null || formData === void 0 ? void 0 : formData.full_name
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InputPhoneNumber, {
    className: stl.rowData,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.phone_number,
    onChange: function onChange(value) {
      setFormItemProxy("phone_number", value);
    },
    errorLabel: getErrMsg("phone_number")
  }), /*#__PURE__*/React.createElement("label", {
    className: stl.whtsFlx
  }, /*#__PURE__*/React.createElement("input", {
    onChange: function onChange(target) {
      var new_value = formData !== null && formData !== void 0 && formData.whatsapp_optin ? 0 : 1;
      setFormItemProxy("whatsapp_optin", new_value);
    },
    defaultChecked: formData === null || formData === void 0 ? void 0 : formData.whatsapp_optin,
    type: "checkbox",
    name: "whatsapp_optin"
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.boxDummy
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/wpImg.svg",
    alt: "whts",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", null, t("أود التواصل واستقبال تحديثات طلبي عن طريق الواتساب", {
    ns: "web_checkout_cash"
  })))), /*#__PURE__*/React.createElement(CustomInput, {
    name: "city_id",
    className: stl.rowData,
    label: t("المدينة", {
      ns: "web_checkout_cash"
    }),
    type: "select",
    referralData: referralData,
    handleChange: function handleChange(value) {
      setFormItemProxy("city_id", Number(value));
      var msg = t("تم تحديث كلفة الشحن", {
        ns: "web_checkout_cash"
      });
      showToast(msg);
    },
    options: cities && [{
      name: t("اختر", {
        ns: "web_checkout_finance"
      }),
      id: ""
    }].concat(_toConsumableArray(cities)),
    selected: formData === null || formData === void 0 ? void 0 : formData.city_id,
    error: getErrMsg("city_id")
  }), /*#__PURE__*/React.createElement("p", {
    className: "".concat(stl.smallNote, " ").concat(getErrMsg("city_id") ? stl.pt10 : "")
  }, t(" سيتم اضافة تكاليف شحن السيارة لمدينتك على المبلغ الاجمالي", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("hr", {
    className: "".concat(stl.hr, " m-hide")
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.codeContainer
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.subHdr
  }, t("هل يوجد لديك كود؟", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement(Tag, {
    selectedTag: function selectedTag(target) {
      setFormItemProxy("code", target === null || target === void 0 ? void 0 : target.code);
    },
    tags: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.discounts,
    value: formData === null || formData === void 0 ? void 0 : formData.code,
    onClick: function onClick(value) {
      setFormItemProxy("code", value);
      activateTheCode(value);
    },
    withPopUp: true
  }), /*#__PURE__*/React.createElement(CustomInput, {
    name: "code",
    className: stl.rowData,
    label: t("كود الخصم", {
      ns: "web_checkout_cash"
    }),
    type: "text",
    placeholder: t("اكتب كود الخصم", {
      ns: "web_checkout_cash"
    }),
    hasButton: true,
    buttonText: t("تفعيل الكود", {
      ns: "web_checkout_cash"
    }),
    ErrorInCode: getErrMsg("code"),
    ErrorMsg: getErrMsg("code"),
    value: formData === null || formData === void 0 ? void 0 : formData.code,
    resetCode: action__resetPromoCode,
    handleChange: function handleChange(target) {
      setFormItemProxy("code", target.value);
      if (!target.value) {
        action__resetPromoCode();
      }
    },
    buttonFunction: function buttonFunction() {
      return activateTheCode(formData === null || formData === void 0 ? void 0 : formData.code);
    },
    isValid: referralData === null || referralData === void 0 ? void 0 : referralData.valid,
    referralMsg: referralData === null || referralData === void 0 ? void 0 : referralData.title
  })), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_is_new) != 1 && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.is_warranty_10_day) && /*#__PURE__*/React.createElement(NDayGuarantee, {
    className: "m-show",
    img: CDN_LINK + "/assets/images/dm10.svg"
  }), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_is_new) == 1 && /*#__PURE__*/React.createElement("p", {
    className: [stl.smallNote, stl.noteBtm].join(" ")
  }, /*#__PURE__*/React.createElement("strong", null, t("تنويه", {
    ns: "web_checkout_cash"
  })), t(": بعد دفع العربون سنقوم بحجز السيارة لك من المعرض خلال 24 ساعة. في حالة لم نتمكن من حجز السيارة لك بسبب نفاذ الكمية أو عدم توفرها لأي سبب كان فسوف نقوم بإعادة العربون لك.", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: [stl.smallNote, stl.noteBtm].join(" ")
  }, !(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.post_is_new) && t("- هذا العربون مسترد بالكامل حتى مرحلة تسجيل السيارة، وسيتم خصم العربون من المبلغ الإجمالي..", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.contBtnContainer
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "greenBtn",
    disabled: buttonLoading
  }, /*#__PURE__*/React.createElement("strong", null, t("اكمل لدفع العربون", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder && checkoutOrder.arboun, /*#__PURE__*/React.createElement("span", {
    className: "text-lg"
  }, t("ريال", {
    ns: "web_checkout_cash"
  }))))))), /*#__PURE__*/React.createElement(ChangeAccountVerificationModal, {
    show: showVerificationModal,
    onClose: function onClose() {
      return setShowVerificationModal(false);
    },
    onSubmit: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setShowVerificationModal(false);
            _context3.next = 3;
            return logout(null);
          case 3:
            handleSubmit();
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })),
    newPhoneNumber: formData === null || formData === void 0 ? void 0 : formData.phone_number,
    loading: buttonLoading
  }));
};
export default ShopApplyForm;